import {createContext} from 'react'

const ProveedoresContext = createContext()

export default ProveedoresContext